import { render, staticRenderFns } from "./Followlist.vue?vue&type=template&id=a2158330&scoped=true"
import script from "./Followlist.vue?vue&type=script&lang=js"
export * from "./Followlist.vue?vue&type=script&lang=js"
import style0 from "./Followlist.vue?vue&type=style&index=0&id=a2158330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2158330",
  null
  
)

export default component.exports